import React from "react"
import DOMPurify from "dompurify"

export interface TypographyProps {
    content?: string
}

export function Typography ({ content = "", ...props }: TypographyProps) {
      const clean = DOMPurify.sanitize(content)
      return (
          <article
              className={"prose max-w-none"}
              dangerouslySetInnerHTML={{ __html: clean }}
              {...props}
          />
      )
  }
